<mat-form-field 
  id="{{idx}}-mat-form-field" 
  appearance="outline"
  [hideRequiredMarker]="true"
  [formGroup]="group"
  subscriptSizing="dynamic"
  [attr.data-label]="placeholder"
>
  <mat-label>{{ placeholder }}</mat-label>
  <input matInput
    (focus)="onFocus()"
    (blur)="onBlur()"
    id="{{ idx }}"
    [formControlName]="controlName"
    [maxlength]="maxlength"
    [minlength]="minlength"
    [type]="type"
    [dropSpecialCharacters]="false"
    [prefix]="prefixT"
    [attr.autocomplete]="autocomplete"
    [attr.aria-required]="required ? 'true' : null"
    [attr.aria-describedby]="'hint_' + idx"
    [mask]="mask">
    @if (suffix) {
      <mat-icon matSuffix aria-hidden="true">{{ suffix }}</mat-icon>
    }
    <mat-hint id="hint_{{idx}}" aria-live="off">{{ content.hint }}</mat-hint>
    @if (group.controls[controlName].invalid) {
      <mat-error aria-live="off">Error: {{ content.hint }} {{ validationMessage.get(group.controls[controlName], placeholder) }}</mat-error>
    }
  </mat-form-field>